const _prefix = '@session/';

export default {
  CACHE_PREV_LOGIN_ROUTE: _prefix + 'CACHE_PREV_LOGIN_ROUTE',
  LOG_IN_REQUEST: _prefix + 'LOGIN_REQUEST',
  LOG_IN_SUCCESS: _prefix + 'LOGIN_SUCCESS',
  LOG_IN_ERROR: _prefix + 'LOGIN_ERROR',
  REAUTHORIZE: _prefix + 'REAUTHORIZE', // throw when API return 401
  RESTORE_SESSION_SUCCESS: _prefix + 'RESTORE_SESSION_SUCCESS', // validate session success
  RESTORE_SESSION_FAILURE: _prefix + 'RESTORE_SESSION_FAILURE', // validate session failure
  LOG_OUT: _prefix + 'LOG_OUT',
  LOGIN_OTP_REQUEST: _prefix + 'LOGIN_OTP_REQUEST',
  CHECK_ACTIVITY: _prefix + 'CHECK_ACTIVITY'
};
